export default __webpack_public_path__ + "static/media/payment list.7292563e.svg";